export var DEPLOY_DATE = new Date('2026-09-25T15:08:50+0000');
